import { render, staticRenderFns } from "./iconP4.vue?vue&type=template&id=16f970ee&scoped=true&"
import script from "./iconP4.vue?vue&type=script&lang=js&"
export * from "./iconP4.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16f970ee",
  null
  
)

export default component.exports